// src/pages/client/Reporting.jsx
import React from 'react';
import ClientNavbar from '../../components/client/ClientNavbar';
import Footer from '../../components/client/Footer';
import kpichart from "../../Assets/Screenshots/kpichart.png";
import InteractiveDashboardPreview from '../../components/client/InteractiveDashboardPreview';
import CalltoAction from '../../components/client/CalltoAction';
import { Link } from 'react-router-dom';
import AnalyticsChart from '../../components/client/AnalyticsChart'; // Import du nouveau composant



const Reporting = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 ">
      <ClientNavbar />
      {/* Section Hero avec texte à gauche et SVG à droite */}
      <div className="py-16 bg-gradient-to-r from-slate-800 to-slate-900">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            {/* Texte à gauche */}
            <div className='text-white'>
              <div className='mb-6'>
                  <h1 className="text-5xl font-bold  mb-6 leading-tight">
                    Transformez vos données en décisions
                 </h1>
              </div>
              <div className=' mb-8 '>
                <p className="text-xl  leading-relaxed">
                Analysez vos performances de recrutement avec des tableaux de bord 
                intelligents. Identifiez les tendances, optimisez vos processus et 
                prenez des décisions basées sur des données concrètes.
              </p>
              </div>
              
              
              <div className="flex flex-col sm:flex-row gap-4">
                <Link to='/contact'>
                 <button className="bg-indigo-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-indigo-700 transition">
                  Commencer gratuitement
                </button>
                </Link>
               
                
              </div>
            </div>
            
            {/* SVG à droite */}
            <div className="flex justify-center ">
              <AnalyticsChart 
                className="w-full max-w-2xl h-auto 
                          animate-[fadeIn_1.5s_ease-out,slideInRight_1.2s_ease-out] 
                          hover:scale-105 hover:rotate-1 
                          transition-all duration-500 
                          drop-shadow-2xl hover:drop-shadow-[0_25px_25px_rgba(0,0,0,0.15)]
                          cursor-pointer"
              />
            </div>
          </div>
        </div>
      </div>
      
      <div className=''>
        <InteractiveDashboardPreview/>
      </div>
      <CalltoAction/>
      


      <Footer />
    </div>
  );
};

export default Reporting;